import { IDataProducto } from "@/shared/interfaces"
import { MRT_ColumnDef } from "material-react-table"
import { useMemo } from "react"

const useTableProductos=()=>{
    const columnsProductos:MRT_ColumnDef<IDataProducto>[]= useMemo<MRT_ColumnDef<IDataProducto>[]> (
        ()=>[
        {
         accessorKey:'codigo',
         header:'Codigo'
        },
        {
         accessorKey:'descripcion',
         header:'descripcion'
        },
        {
        accessorKey:'marca_producto',
        header:'marca',
        Cell:({row})=>row.original?.marca_producto ?? 'N/A'
        },
        {
        accessorKey:'modelo_producto',
        header:'modelo',
        Cell:({row})=>row.original?.modelo_producto ?? 'N/A'
        },
        {
         accessorKey:'unidad_medida',
         header:'Medida',
          Cell:({row})=>(row.original?.unidad_medida || row.original?.unidad_medida_data?.nombre) ?? 'N/A'
        }
        ],
        []
    )

    return{
        columnsProductos
    }
        
    

}
export default useTableProductos;